import DashboardLayout from 'src/components/Dashboard/Layout/DashboardLayout.vue'

const Admin = () => import(/* webpackChunkName: "lottery" */ './Admin')
const Screen = () => import(/* webpackChunkName: "lottery" */ './Screen')

export default [
  {
    path: '/lottery/passage/:lotteryId',
    name: 'lottery-passage-admin',
    component: Admin,
    meta: {
      auth: true,
    }
  },
  {
    path: '/lottery/passage/:lotteryId/screen',
    name: 'lottery-passage-screen',
    component: Screen,
    meta: {
      auth: true
    }
  }
]
